import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors, fonts, media, pxToRem, theme } from '@vfit/shared/themes';

export const ShoppingCartAddressBar = styled.div<{ embedded?: boolean }>`
  display: flex;
  align-items: center;
  align-content: center;
  align-self: stretch;
  flex-wrap: wrap;
  gap: ${pxToRem(16)};
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;


  ${({ embedded }) =>
    embedded
      ? css`
          padding: 0;

          ${media.tablet`
            flex-wrap: nowrap;
          `}
        `
      : css`
          padding: ${pxToRem(24)} ${pxToRem(24)} 0;

          ${media.tablet`
            flex-wrap: nowrap;
            padding: ${theme.spacing.xl} ${theme.spacing.xl} 0;
          `}

          ${media.largeDesktop`
            padding: 0;
            margin-bottom: ${pxToRem(16)};
          `}
        `}
`;

export const AddressLogoWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const AddressText = styled.span`
  color: ${colors.$262626};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: ${fonts.regular};
  font-size: ${pxToRem(16)};
  font-style: normal;
  font-weight: 700;
  line-height: ${pxToRem(20)};
  letter-spacing: 0;
  flex: 1 1 0;
  min-width: 0;
  white-space: break-spaces;

  ${media.tablet`
    flex: 0 1 auto;
  `}
`;

export const AddressRowBreak = styled.span`
  flex-basis: 100%;
  width: 0;
  height: 0;
  overflow: hidden;

  ${media.tablet`
    display: none;
  `}
`;

export const EditAddressLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${colors.$262626};
  font-family: ${fonts.regular};
  font-size: ${pxToRem(16)};
  font-style: normal;
  font-weight: 700;
  line-height: ${pxToRem(22)};
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-underline-offset: auto;
  white-space: nowrap;
  align-self: flex-start;
  text-align: left;

  ${media.tablet`
    align-self: center;
    line-height: ${pxToRem(20)};
    margin-left: ${pxToRem(-6)};
  `}

  &:hover,
  &:active {
    color: ${colors.$e60000};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
